import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import { captureAttribution } from './utilities/attribution';
import { loadWebAnalytics } from './utilities/web-analytics';

// Once per page load, rather than per route change: only the first page of a
// visit has a referrer or campaign tags worth recording
captureAttribution();

loadWebAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
